import React from 'react';
import { TextField } from '@mui/material';
import { NumericFormat } from 'react-number-format';

const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(props, ref) {
    const { onChange, name, prefix, ...other } = props;

    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: name,
                        value: values.value, 
                    },
                });
            }}
            thousandSeparator="."
            decimalSeparator=","
            valueIsNumericString
            prefix={prefix || ""}
            decimalScale={2}
            fixedDecimalScale
        />
    );
});

export default function TextfieldMontos({ 
    variant, 
    disabled, 
    size, 
    name, 
    value, 
    onChange, 
    label, 
    prefix, 
    inputsx, 
    inputProps,
    helperText
}) {
    return (
        <TextField
            fullWidth
            disabled={disabled}
            variant={variant}
            size={size}
            name={name}
            value={value}
            label={label}
            onChange={onChange}
            sx={inputsx}
            InputProps={{
                inputComponent: NumericFormatCustom,
                inputProps: {
                    name,
                    prefix,
                    ...inputProps?.inputProps 
                }
            }}
            helperText={helperText}
        />
    );
}